const translations = {
  'forthcomingCourses.title': 'Forthcoming TEFL Courses',
  'forthcomingCourses.btn.applyNow': 'Apply Now',
  'forthcomingCourses.homepage.nextDate': 'Next date',
  'forthcomingCourses.title.upcoming': 'Barcelona TEFL Course Dates',
  'forthcomingCourses.placecAvailable': 'Places available',

  'forthcomingCourses.course': 'Course',
  'forthcomingCourses.from': 'From',
  'forthcomingCourses.to': 'To',
  'forthcomingCourses.price': 'Price',

  'activeComingCourses.notice':
    ' Developing Teacher course and Young Learners course have flexible start dates. Contact us for <accentedLink>more information.</accentedLink>',
  'forthcomingCourses.description':
    'The Teaching Young Learners Course follows the same start dates as our Trinity CertTESOL course. See our <accent> course dates page </accent> for more information.',
  'graduates.title': 'From our Graduates',
  'graduates.teflSpanishCourses.title':
    'We’ve Helped Hundreds Of Students Qualify As A Teacher And Find Work In Overseas. Are You Next? ',
  'graduates.teflSpanishCourses.description': 'Check out what these past students had to say',
  'graduates.description': '',
  'graduates.seeAllReviews': 'See All Reviews',
  'graduates.testimonials': 'Testimonials',
  'graduates.spanish.title':
    'Hemos Ayudado A Cientos De Estudiantes A Aprender Inglés. ¿Eres Tú El Siguiente?',
  'forthcomingCourses.active.showLess': 'Show Less Dates',
  'forthcomingCourses.active.loadMore': 'Load More Dates',
  'studentSupport.title': 'Student Support',
  'studentSupport.description': 'Learn about our additional services',
  'studentSupport.accommodation': 'Accommodation',
  'studentSupport.studentVisa': 'Student Visa',
  'studentSupport.culture': 'Culture',
  'studentSupport.bureaucracy': 'Bureaucracy',
  'appProcess.title': 'The Trinity CertTESOL Application Process',
  'appProcess.ben1.title': 'Application',
  'appProcess.ben1.text':
    'Check out our <accent>  entry requirements </accent> and <accent2>  how to make a good application</accent2>. Fill out your online application and start the process.',
  'appProcess.ben2.title': 'Language awareness task',
  'appProcess.ben2.text':
    'After submitting your form, you will be directed to a quick 10-minute online test that assesses your suitability for the TEFL course content.',
  'appProcess.ben3.title': 'Interview',
  'appProcess.ben3.text':
    'Once you pass your test, you will be matched with a course coordinator for a 20-30 minute discussion covering the course content. You can also take the opportunity to ask as many questions as you like.',
  'appProcess.ben4.title': 'Registration',
  'appProcess.ben4.text':
    'We will organise tuition payment and your place on the course will be confirmed.',
  'appProcess.ben5.title': 'The course begins!',
  'appProcess.ben5.text':
    'The fun, expert-level English teacher training begins! Once you arrive in Spain you’re only a few weeks away from a new career as an English teacher.',
  'appProcess.ben5.text.onlineCourse':
    'The fun, expert-level English teacher training begins! You’ll be given access to our live online sessions and you’re only a few weeks away from a new career as an English teacher.',
  'pricingCard.btn.checkDates': 'Check Dates',
};

export default translations;
